export default __webpack_public_path__ + "static/media/travel-guru.191a5d76.png";